import React from "react";

function Feedback({
  showFeedback,
  setShowFeedback,
  showFeedbackThanks,
  setShowFeedbackThanks,
}) {
  function handleSubmitFeedback() {
    setShowFeedback(false);
    setShowFeedbackThanks(true);
  }
  return (
    <div
      className={
        showFeedback
          ? "absolute top-0 left-0 z-10 bg-[rgba(0,0,0,0.8)] w-full h-full  "
          : "hidden"
      }
    >
      <div className="flex justify-center items-center z-10 bg-[rgba(0,0,0,0.9)]  absolute top-2 left-[50%] transform -translate-x-1/2 ">
        <div className="text-[#2A5801] bg-white rounded-[10px] px-[30px] py-[20px]">
          <h1 className="text-2xl">FEEDBACK FORM </h1>
          <p className="mt-[20px]">
            Please take a moment to share your thoughts and insights. Your input
            will help is enhance this exercise and make it more benficial for
            you and others.
          </p>
          <form className="mt-[50px]">
            <input
              className="w-full h-[180px] border-[2px] border-[#2A5801] rounded-[10px]"
              type="text"
              placeholder="Your feedback here"
            />
          </form>
          <h1 className="mt-[20px] text-2xl">RATE</h1>
          <div className="flex">
            <p>1= Good</p>
            <p className="ml-[170px]">5= Excellent</p>
          </div>
          <img
            className="mt-[-16px]"
            src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701779838/Arrow_57_ybcohk.png"
            alt=""
          />
          <div className="flex">
            <img
              className="mr-[12px]"
              src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701779846/Star_1_fckanu.png"
              alt=""
            />
            <img
              className="mr-[12px]"
              src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701779846/Star_1_fckanu.png"
              alt=""
            />
            <img
              className="mr-[12px]"
              src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701779846/Star_1_fckanu.png"
              alt=""
            />
            <img
              className="mr-[12px]"
              src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701779846/Star_1_fckanu.png"
              alt=""
            />
            <img
              className="mr-[12px]"
              src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701779846/Star_1_fckanu.png"
              alt=""
            />
          </div>
          <p className="mt-[20px]">Tap the stars to choose</p>
          <div className="flex justify-center mt-[20px]">
            <button
              className="bg-[#295700] text-white rounded-[5px] ml-[20px] px-[10px] py-[5px]"
              onClick={handleSubmitFeedback}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      //{" "}
    </div>
  );
}

export default Feedback;
